export const GET_ORGANIZATIONS_REQUEST = 'GET_ORGANIZATIONS_REQUEST';
export const GET_ORGANIZATIONS_SUCCESS = 'GET_ORGANIZATIONS_SUCCESS';
export const GET_ORGANIZATIONS_FAIL = 'GET_ORGANIZATIONS_FAIL';
export const GET_ORGANIZATIONS_CANCEL = 'GET_ORGANIZATIONS_CANCEL';
export const getOrganizationsRequest = (data, abortController) => ({
  type: GET_ORGANIZATIONS_REQUEST,
  payload: data,
  abortController,
});
export const cancelOrganizationsRequest = () => ({
  type: GET_ORGANIZATIONS_CANCEL,
});

export const UPDATE_ORGANIZATION = 'UPDATE_ORGANIZATION';
export const updateOrganization = (data) => ({
  type: UPDATE_ORGANIZATION,
  payload: data,
});

export const UPDATE_ORGANIZATIONS = 'UPDATE_ORGANIZATIONS';
export const updateOrganizations = (organizations) => ({
  type: UPDATE_ORGANIZATIONS,
  payload: organizations,
});

export const REMOVE_ORGANIZATION = 'REMOVE_ORGANIZATION';
export const removeOrganization = (data) => ({
  type: REMOVE_ORGANIZATION,
  payload: data,
});
